import { ApiName } from '@periscopes/general/ApiName';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DeploymentStatusTag } from '@ui/tags';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import React from 'react';
import { SalesforceDescription } from '@ui/text';
import { usePeriscopeMetadata } from '@hooks';

import { GoToDictionaryButton, InformationSection, IngestedBySection, PopulatedBySection } from '@periscopes/general';
import { InlineCheckmarkMetadata, InlineMetadata } from '@periscopes/general/metadata';
import { PeriscopeSfEntityMetadata, SonarObjectType } from '@sonar-software/sonar-ts-types';

export interface EntityInformationProps {
	sonarObjectId: number;
}

export const EntityInformation: React.FC<EntityInformationProps> = ({ sonarObjectId }) => {
	const { loading, metadata } = usePeriscopeMetadata<PeriscopeSfEntityMetadata>(
		sonarObjectId,
		SonarObjectType.SalesforceEntity
	);

	if (loading) {
		return <LoadingSpinner spinning />;
	}

	return (
		<InformationSection
			headerAction={ <GoToDictionaryButton sonarObjectId={ sonarObjectId } /> }
			sonarObjectId={ sonarObjectId }>
			<ApiName sonarObjectId={ sonarObjectId } />
			<SalesforceDescription sonarObjectId={ sonarObjectId } />
			<InlineCheckmarkMetadata
				label={ COPY_SPECIFIC.ENABLE_REPORTS }
				value={ metadata?.allowReports } />
			<InlineCheckmarkMetadata
				label={ COPY_SPECIFIC.TRACK_ACTIVITIES }
				value={ metadata?.allowActivities } />
			<InlineCheckmarkMetadata
				label={ COPY_SPECIFIC.TRACK_FIELD_HISTORY }
				value={ metadata?.trackFieldHistory } />
			<InlineMetadata label={ COPY_SPECIFIC.DEPLOYMENT_STATUS }>
				<DeploymentStatusTag status={ metadata?.deploymentStatus } />
			</InlineMetadata>
			<IngestedBySection sonarObjectId={ sonarObjectId } />
			<PopulatedBySection sonarObjectId={ sonarObjectId } />
		</InformationSection>
	);
};
